<template>
  <div
    v-if="hasOnboardingV3 && !skippableOnboarding"
    class="onboarding-show-animation ai-onboarding"
    :class="{
      'show': isOnboardingV3Showing,
      'onboarding-feature-based-options': true,
    }"
    :style="{
      '--onboarding-bg-img': `url(${onboardingBgImg})`,
    }"
  >
    <user-screening
      v-if="showUserScreening"
      @skip="hideUserScreening = true"
      @done="hideUserScreening = true"
    ></user-screening>
    <LoadingScreen v-if="isLoadingFeatures && !showUserScreening" />
    <OnboardingFeatureBasedOptions v-if="!isLoadingFeatures && !showUserScreening" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Config from '@/config'
import utils from '@/util'

import OnboardingFeatureBasedOptions from '@/components-v2/onboarding/OnboardingFeatureBasedOptions.vue'
import UserScreening from '@/components-v2/modals/UserScreening.vue'
import LoadingScreen from '@/components-v2/common/loading/LoadingScreen.vue'

const ONBOARDING_BG_IMG = `${Config.cloudfrontPublic}/feature-based-options/common/Background.svg`

export default {
  components: {
    OnboardingFeatureBasedOptions,
    UserScreening,
    LoadingScreen,
  },
  props: {
    hasOnboardingV3: {
      type: Boolean,
      default: true,
    },
    isOnboardingV3Showing: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      hideUserScreening: false,
      onboardingBgImg: ONBOARDING_BG_IMG,
    }
  },
  computed: {
    ...mapState({
      presenterLocale: (state) => state.presenterLocale,
    }),
    ...mapGetters('onBoarding', [
      'skippedScreening',
      'hasDoneScreening',
      'skippableOnboarding',
    ]),
    ...mapGetters('featureToggles', [
      'isLoadingFeatures',
    ]),
    showUserScreening() {
      const skipped = this.skippedScreening || this.hideUserScreening

      return !this.hasDoneScreening && !skipped
    },
  },
  created() {
    this.preloadOnboardingAssets()
  },
  methods: {
    preloadOnboardingAssets() {
      utils.preloadOnboardingV4Assets()
    },
  },
}
</script>

<style lang="scss" scoped>
.onboarding-show-animation {
  left: -100%;
  transition: 0.5s ease;
  z-index: 3;
  &.show {
    left: 0;
  }
}

.ai-onboarding {
  @apply w-full h-full bg-primary-50;
  position: absolute;
  display: grid;
  overflow: auto;
  grid-template-columns: minmax(1rem, 1fr) [center-start] auto [center-end] minmax(1rem, 1fr);
  grid-template-rows: minmax(100px, 1fr) [center-start] auto [center-end] minmax(70px, 1fr);

  @media (max-width: 768px) {
    grid-template-rows: minmax(76px, 1fr) [center-start] auto [center-end] minmax(70px, 1fr);
  }

  &::v-deep {
    & > * {
      grid-column: center-start / center-end;
      grid-row: center-start / center-end;
    }
  }
}

.onboarding-feature-based-options {
  display: block !important;
  padding-top: 3.75rem;
  height: 100%;
  background-image: var(--onboarding-bg-img);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
